export default __webpack_public_path__ + "static/media/logoOperadora.eb4c7377.jpg";